var _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 315,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M0 0h240v315H0z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 34,
    fill: "#CFE8FC",
    rx: 173,
    ry: 60,
    transform: "rotate(-180 120 34)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.5,
    cy: 241,
    fill: "#CFE8FC",
    rx: 169.5,
    ry: 145,
    transform: "rotate(-180 120.5 241)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlue);
export default __webpack_public_path__ + "static/media/backgroundBlue.f181bc63979a77c60b03082f34211477.svg";
export { ForwardRef as ReactComponent };